import axios from "axios";
import { Cookies } from "react-cookie";
import { store } from "../store";

const api = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const userDetails = store.getState()?.user?.userDetails;
    const dynamicBaseUrl = userDetails?.base_url || userDetails?.address;

    config.baseURL = dynamicBaseUrl || process.env.REACT_APP_BASE_URL;

    const cookies = new Cookies();
    const { token, passwordToken } = cookies.getAll();

    // Auth handling
    if (config.url === "resetpassword") {
      config.headers.Authorization = `Bearer ${passwordToken}`;
      return config;
    }

    if (token && token !== "null") {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
